import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useQuery } from "~/Hooks/useQuery";
import { AddEditAdsPromotion } from "./AddEditAdsPromotion";
import { AddEditAdsBrands } from "./AddEditAdsBrands";
import { AddEditAdsTopSelling } from "./AddEditAdsTopSelling";
import { AddEditAdsNews } from "./AddEditNews";

export const AdsBanner = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const bannerItems = [
    {
      label: "Promotion",
      key: "bannerPromotion",
      children: <div><AddEditAdsPromotion /></div>,
    },
    {
      label: "Browse by Brands",
      key: "bannnerBrands",
      children: <div><AddEditAdsBrands /></div>,
    },
    {
      label: "Top Selling",
      key: "bannerTopSelling",
      children: <div><AddEditAdsTopSelling /></div>,
    },
    {
      label: "News",
      key: "bannerNews",
      children: <div><AddEditAdsNews /></div>,
    },
  ];

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={bannerItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=banner&subActiveTab=${activeKey || 'bannerPromotion'}`);
      }}
    ></Tabs>
  );
};
